/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import FormLabel from 'components/pages/ResourceSetting/Widgets/FormLabel';
import FormFileDrop from 'components/pages/ResourceSetting/Widgets/FormFileDrop';
import googleContentFeed from 'assets/ProductFeedExample.xlsx';
import Styles from './index.module.css';

export default function ContentFeedField({
  value,
  onChange,
  link,
  ...props
}) {
  return (
    <div className={Styles.mainContainer} {...props}>
      <FormLabel
        title="新增產品資訊檔案"
        description=""
        required="true"
      />
      <div className={Styles.fileDropContainer}>
        <a href={link} className={Styles.fileDropLink}>
          下載產品資訊檔案範例
        </a>
        <FormFileDrop
          onSelectFile={(files) => {
            if (files[0]) {
              const name = (files[0].name || '').toLowerCase();
              const allowedExtensions = ['.csv', '.xlsx', '.xls', '.numbers'];
              let allowed = false;
              for (let i = 0; i < allowedExtensions.length && !allowed; i += 1) {
                if (name.endsWith(allowedExtensions[i])) allowed = true;
              }
              if (!allowed) return;
            }
            onChange(files[0]);
          }}
          selectedFilename={value}
          title="產品資訊檔案(限為Excel檔)"
          description="請上傳全館商品清單"
        />
      </div>
    </div>
  );
}

ContentFeedField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  link: PropTypes.string,
};

ContentFeedField.defaultProps = {
  value: '',
  onChange: () => {},
  link: googleContentFeed,
};
